import { render, staticRenderFns } from "./Asset-Photos.vue?vue&type=template&id=16c65fd2&"
import script from "./Asset-Photos.vue?vue&type=script&lang=ts&"
export * from "./Asset-Photos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports